export const CORVID_APP_DEF_ID = '675bbcef-18d8-41f5-800e-131ec9e08762'
export const CORVID_BACKEND_CODE_APP_DEF_ID = '151e476a-715e-ec33-db9a-a7ff4d51f70a'

export const DUPLEXER = {
	subscriptionSucceeded: '@duplexer:subscription_succeeded',
	unsubscribeSucceeded: '@duplexer:unsubscribe_succeeded',
	subscriptionFailed: '@duplexer:subscription_failed',
	connected: '@duplexer:connected',
	disconnected: '@duplexer:disconnected',
	connectError: '@duplexer:connect_error',
}
